import { createFileRoute } from '@tanstack/react-router';
import { PartnerLinkPage } from '@/features/partner-link/partner-link-page';

// Partner account-linking entry (e.g. Swiggy → ixigo rewards linking); see
// docs/swiggy-account-linking.md. Partners open this URL inside their app's
// webview with a per-user requestId; the page forces a fresh OTP-only login,
// mints the encrypted SSO token and redirects to the partner's callback URL.
interface PartnerLinkSearch {
	utm_source?: string;
	requestId?: string;
	utm_medium?: string;
	utm_campaign?: string;
}

// The router's search parser JSON-parses values, so a numeric-looking param
// (e.g. requestId=12345) arrives as a number — normalise back to the string
// the partner sent; absent/empty stays undefined.
function asParam(value: unknown): string | undefined {
	if (value == null || value === '') return undefined;
	return typeof value === 'string' ? value : String(value);
}

export const Route = createFileRoute('/ixi-finance/partner/link')({
	validateSearch: (search: Record<string, unknown>): PartnerLinkSearch => ({
		utm_source: asParam(search.utm_source),
		requestId: asParam(search.requestId),
		utm_medium: asParam(search.utm_medium),
		utm_campaign: asParam(search.utm_campaign),
	}),
	component: PartnerLinkPage,
	ssr: false,
	// Machine-to-machine entry point — never indexed.
	head: () => ({
		meta: [{ name: 'robots', content: 'noindex, nofollow' }],
	}),
});
